<template>
  <div id="main" class="handle-main-style">

    <div class="handle-condition" v-for="(item, index) in list" :key="index">
      <div class="table-search-style">
        <slot :name="item"></slot>
      </div>
      <whSquareButton class="search-squareButton-revise-style" iconValue="#icon-search" @click.native="handleClickSearch"></whSquareButton>
    </div>

    <div class="handle-condition" v-if="$slots.moreSearch">
      <el-popover
        placement="bottom-start"
        trigger="click"
        :width="popoverWidth"
        :offset="leftOffset"
      >
        <el-badge slot="reference" value="更多查询">
          <whSquareButton size="small" iconValue="#icon-moreSearch"></whSquareButton>
        </el-badge>
        <div class="condition-screening">

          <slot name="moreSearch"></slot>

        </div>

      </el-popover>
    </div>

    <div class="handle-condition" :class="{'right-button-group-style':!$slots.buttonGroup}" style="margin-left: auto">

      <el-divider direction="vertical"></el-divider>

      <el-button class="table-operation-style" type="text" size="small" @click="handleClickSearch">
        刷新表格<i class="el-icon-refresh-right el-icon--right"></i>
      </el-button>

      <el-divider direction="vertical"></el-divider>

      <el-dropdown v-if="$slots.dropdownItem">
        <el-button class="table-operation-style" type="text" size="small">
          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <slot name="dropdownItem"></slot>
        </el-dropdown-menu>
      </el-dropdown>

      <el-divider v-if="$slots.dropdownItem" direction="vertical"></el-divider>

    </div>

    <div class="handle-condition right-button-group-style">
      <slot name="buttonGroup"></slot>
    </div>

  </div>
</template>
<script>
import mixins from '@/mixins';
export default {
  mixins: [mixins],
  name: "HandleBar",
  data() {
    return {
      popoverWidth: '',
      leftOffset: '',
      list: [],
    };
  },
  computed: {

  },
  components: {

  },
  mounted() {
    document.onkeyup = () => {
      if (window.event.keyCode == 13) {
        this.handleClickSearch();
      }
    };
  },
  created() {
    for (let i = 0; i < 20; i++) {
      const newSearch = "search" + i;
      if (this.$slots[newSearch]) {
        this.list.push(newSearch);
        this.leftOffset = this.leftOffset - 265;
      }
    }
  },
  methods: {
    handleClickSearch() {
      this.$emit('search');
    }
  },
}

</script>
<style lang="scss">

//表格顶部右侧按钮组样式
.right-button-group-style {
  margin-right: 0 !important;
}

//表格顶部刷新、排序、批量等操作按钮的样式
.table-operation-style {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}

//更多搜索弹出框样式
.condition-screening {
  padding: 16px 0 0 16px;
  margin: 0 -12px -12px 0;
  font-size: 0;
}

//徽章样式
.handle-condition .el-badge__content.is-fixed {
  -webkit-transform: scale(0.8);
  font-size: 10px;
  margin-right: -50px;
  margin-top: -10px;
}

//搜索按钮的修正样式
.search-squareButton-revise-style.square-button {
  margin-left: -1px !important;
}

//表格上方操作菜单的子布局样式
.handle-condition {
  display: inherit;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 16px;
  margin-bottom: 28px;
}

//表格上方操作菜单的总布局样式
.handle-main-style {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
}

//面包屑内层调整flex交叉轴居中样式
.sth-breadcrumb-inner-style {
  margin-top: -25px;
}

//面包屑内层调整Tab的按钮组样式
.sth-breadcrumb-button-group {
  margin-left: 48px;
  margin-top: -25px;
}

//重写下拉框中输入框的宽度
.table-search-style .el-select>.el-input {
  display: block;
  width: 218px !important;
}

//重写级联选择框中输入框的宽度
.table-search-style .el-cascader>.el-input {
  display: block;
  width: 218px !important;
}

//重写日期选择框中输入框的宽度
.table-search-style .el-date-editor.el-input {
  display: block;
  width: 218px !important;
}

//重写级联选择框中线高
.table-search-style .el-cascader {
  line-height: unset !important;
}

//重写更多搜索中输入和下拉框的样式，默认size="small"
.search-condition .el-input .el-input__inner {
  font-size: 12px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.table-search-style .el-input .el-input__inner {
  font-size: 12px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.search-condition .el-input__icon {
  font-size: 12px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.table-search-style .el-input__icon {
  font-size: 12px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.search-condition .el-button {
  font-size: 12px !important;
  padding: 9px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/handleBar/handleBar.vue